import { SvgIcon } from "@mui/material"
import { ReactComponent as PrintIcon } from 'assets/icons/Print.svg';

const useHeaderBtns = () => {

    const headerBtns = [
        {
            id: 0,
            label: 'הדפס דו"ח',
            name: "report",
            action: () => { },
            height: "35px",
            // disabled: isEmpty(selectedTestTakers),
            // loading: loading[loadingKeys.printAssessment],
            disabled: true,
            icon: <SvgIcon component={PrintIcon} inheritViewBox />,
        },
    ]

    return headerBtns
}

export default useHeaderBtns